import { ScriptLanguage } from "@/script/model"

// Mirrors Script\Helper::argNames on the backend, which is the authority: it
// derives the node's anchors this way and rejects edges naming anything else.
// This copy exists so the editor can draw handles while you type, without a
// round trip.
const patterns = {
  [ScriptLanguage.JavaScript]: /function\s+execute\s*\(\s*([^)]*)\)/m,
  [ScriptLanguage.Python]: /def\s+execute\s*\(\s*([^)]*)\)/m,
}

const argPatterns = {
  // "$" is a legal identifier character in JS, so it is part of the name.
  [ScriptLanguage.JavaScript]: /^(?:\.\.\.)?([A-Za-z_$][\w$]*)/,
  [ScriptLanguage.Python]: /^\*{0,2}([A-Za-z_]\w*)/,
}

export const argNames = (lang: ScriptLanguage, code: string | undefined) => {
  if (!code) {
    return []
  }
  const m = code.match(patterns[lang])
  const argsStr = m?.[1]
  if (!argsStr?.trim()) {
    return []
  }

  return argsStr // get inside-the-parens
    .split(",") // split args
    .map((a) => a.trim()) // trim whitespace
    .filter((a) => a) // drop empties
    .map((arg) => arg.match(argPatterns[lang])?.[1] ?? "")
    .filter(Boolean)
}

/**
 * Generates a JSON Schema string from function argument names.
 * All parameters are typed as string and required (v1).
 */
export const argsJsonSchema = (
  lang: ScriptLanguage,
  code: string | undefined,
) => {
  const args = argNames(lang, code)

  return JSON.stringify(
    {
      type: "object",
      properties: Object.fromEntries(
        args.map((name) => [name, { type: "string" }]),
      ),
      required: args,
      additionalProperties: false,
    },
    null,
    2,
  )
}
